import React from 'react';
import { Link } from 'react-router-dom';

interface WorkflowStep {
  step: number;
  title: string;
  description: string;
  icon: string;
  color: string;
}

const ServiceTabsSection: React.FC = () => {
  const workflowSteps: WorkflowStep[] = [
    {
      step: 1,
      title: "Take a Test",
      description: "Choose from personalized practice tests designed for JEE and NEET. Our AI adapts the difficulty based on your current level and learning goals.",
      icon: "fas fa-clipboard-check",
      color: "#667eea"
    },
    {
      step: 2,
      title: "Get Instant Results & Gap Analysis",
      description: "Receive detailed performance insights within seconds. Our AI identifies your weak areas and suggests focused study topics to maximize your preparation efficiency.",
      icon: "fas fa-chart-line",
      color: "#764ba2"
    },
    {
      step: 3,
      title: "Talk to WiZiAi Voice Assistant",
      description: "Ask questions naturally using voice commands. Get instant explanations, solve doubts, and understand concepts through interactive conversations with our AI tutor.",
      icon: "fas fa-microphone-alt",
      color: "#2d9cdb"
    },
    {
      step: 4,
      title: "Learn & Improve",
      description: "Follow personalized study paths created by AI. Track your progress, compete with peers, and watch your scores improve with targeted practice sessions.",
      icon: "fas fa-graduation-cap",
      color: "#27ae60"
    }
  ];

  return (
    <div className="container-fluid wiziai-workflow py-5">
      <div className="container py-5">
        <div className="section-title position-relative text-center mx-auto mb-5 pb-4 wow fadeInUp"
          data-wow-delay="0.1s" style={{ maxWidth: "800px" }}>
          <h4 className="text-primary mb-3">How It Works</h4>
          <h1 className="display-4 mb-4">Your Journey to <span className="wiziai-gradient-text">Success</span></h1>
          <p className="mb-0 fs-5">
            Experience a seamless learning journey with WiZiAi. Our intelligent platform guides you through 
            every step of your JEE and NEET preparation, making complex topics simple and success achievable.
          </p>
        </div>
        
        <div className="wiziai-workflow-container">
          <div className="row g-4">
            {workflowSteps.map((step, index) => (
              <div key={step.step} className="col-lg-6 col-xl-3 wow fadeInUp" data-wow-delay={`${0.1 + index * 0.1}s`}>
                <div className="wiziai-workflow-step">
                  <div className="wiziai-workflow-number" style={{ backgroundColor: `${step.color}15`, borderColor: step.color }}>
                    <span style={{ color: step.color }}>{step.step}</span>
                  </div>
                  <div className="wiziai-workflow-icon" style={{ backgroundColor: `${step.color}15`, borderColor: step.color }}>
                    <i className={step.icon} style={{ color: step.color }}></i>
                  </div>
                  <div className="wiziai-workflow-content">
                    <h5 className="wiziai-workflow-title">{step.title}</h5>
                    <p className="wiziai-workflow-description">{step.description}</p>
                  </div>
                  {index < workflowSteps.length - 1 && (
                    <div className="wiziai-workflow-connector">
                      <div className="wiziai-workflow-line"></div>
                      <div className="wiziai-workflow-arrow">
                        <i className="fas fa-arrow-right"></i>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
        
        <div className="text-center mt-5 wow fadeInUp" data-wow-delay="0.6s">
          <div className="wiziai-workflow-cta">
            <Link to="/signup" className="btn btn-primary btn-lg px-5 py-3 me-3">
              Start Your Journey
              <i className="fas fa-play ms-2"></i>
            </Link>
            <Link to="/demo" className="btn btn-outline-primary btn-lg px-5 py-3">
              Watch Demo
              <i className="fas fa-video ms-2"></i>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServiceTabsSection;
